/* eslint-disable no-nested-ternary */
import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import SignUp from '../containers/Mobile/Signup'
import Login from '../containers/Mobile/Login'
import Pesticides from '../containers/Mobile/Pesticides'
import Cart from '../containers/Mobile/Cart'
import Order from '../containers/Mobile/Order'
import Home from '../containers/Mobile/Home'
import PublicRoute from '../RouteTypes/MobileRouteTypes/PublicRoute'
import PrivateRoute from '../RouteTypes/MobileRouteTypes/PrivateRoute'
import UnderMaintenance from '../components/Mobile/UnderMaintenance'
import PesticideByCategory from '../containers/Mobile/PesticideByCategory'
import { privateRoute, publicRoute } from './RouteList/MobileRouteList'
import { ROUTE } from '../utils/User/constants/routingConfig/routeDetails'

const Routes = () => (
  <Switch>

    {publicRoute.map(({ path, component }) => (
      <PublicRoute
        key={ path }
        exact
        path={ path }
        component={ component }
      />
    ))}

    {privateRoute.map(({ path, component }) => (
      <PrivateRoute
        key={ path }
        exact
        path={ path }
        component={ component }
      />
    ))}

    <Route
      exact
      path={ ROUTE.SIGNUP }
      render={ () => (
        JSON.parse(localStorage.getItem('user')) ? <></> : <SignUp />
      ) }
    />
    <Route
      exact
      path={ ROUTE.LOGIN }
      render={ () => (
        JSON.parse(localStorage.getItem('user')) ? <></> : <Login />
      ) }
    />
  </Switch>
)

export default Routes
